import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getCandidates,
  updateCandidateStatus as updateCandidateStatusApi,
} from "../api/candidates.api";

import { CandidateFilters } from "../types";

// =========================================================
// FETCH CANDIDATES
// =========================================================
// NOTE: logic is unchanged from before. `params` used to be an inline type
// literal duplicating CandidateFilters field-for-field; it now imports the
// shared type instead. No runtime behavior change.

export const fetchCandidates = createAsyncThunk(
  "candidates/fetchCandidates",

  async (
    {
      page = 1,
      limit = 25,
      search = "",
      department = "All",
      status = "All",
      minATSScore = "",
    }: CandidateFilters,
    thunkAPI
  ) => {
    try {
      const response = await getCandidates({
        page,
        limit,
        search,
        department,
        status,
        minATSScore,
      });

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// =========================================================
// UPDATE CANDIDATE STATUS
// =========================================================
// Unchanged logic. Typed the payload the API returns just enough to keep
// candidates.slice.ts's existing consumption of
// action.payload.data.applicationId / statusHistory type-safe.

export interface UpdateCandidateStatusResult {
  success?: boolean;
  message?: string;
  data?: {
    applicationId?: string;
    statusHistory?: unknown;
  };
}

export const updateCandidateStatus = createAsyncThunk<
  UpdateCandidateStatusResult,
  { applicationId: string; status: string; reason?: string }
>(
  "candidates/updateCandidateStatus",

  async ({ applicationId, status, reason }, thunkAPI) => {
    try {
      const response = await updateCandidateStatusApi(
        applicationId,
        status,
        reason
      );

      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);